export enum BetPlacementStatus{
    NotStarted = 0,
    InProcess = 1,
    Error = 2,
    Success = 3
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/data/enums/BetPlacementStatus.ts